// En request-data.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RequestDataService {
  private requestDataMap = new Map<string, any>();

  /**
   * Genera un ID único para cada request
   */
  generateRequestId(): string {
    return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  /**
   * Genera un ID de tracing único para el frontend
   */
  generateTraceFrontendId(): string {
    return `trace_fe_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  setRequestData(requestId: string, data: any): void {
    this.requestDataMap.set(requestId, data);
    
    // Limpiar requests antiguos (mantener solo los últimos 20)
    if (this.requestDataMap.size > 20) {
      const firstKey = this.requestDataMap.keys().next().value;
      if (firstKey !== undefined) {
        this.requestDataMap.delete(firstKey);
      }
    }
  }

  getRequestData(requestId: string): any {
    return this.requestDataMap.get(requestId);
  }

  clearRequestData(requestId?: string): void {
    if (requestId) {
      this.requestDataMap.delete(requestId);
    } else {
      this.requestDataMap.clear();
    }
  }

  // Método de respaldo para casos donde no hay requestId
  getLastRequestData(): any {
    const entries = Array.from(this.requestDataMap.entries());
    return entries.length > 0 ? entries[entries.length - 1][1] : null;
  }
}